import { useEffect } from "react";
import { useExtendedRouter } from "hooks";
import { trackUAPageViewed, trackPageView } from "utils/tracking/utils";
import type { UseGTMProps } from "./useGTM.d";

const useGTM = (
  language: UseGTMProps["language"],
  isTrackingLess: UseGTMProps["isTrackingLess"],
  pageReferrer: UseGTMProps["pageReferrer"]
) => {
  const { pathWithoutHash: path } = useExtendedRouter();

  useEffect(() => {
    if (!isTrackingLess) {
      trackUAPageViewed(language, path);
      trackPageView(language, pageReferrer);
    }
  }, [language, isTrackingLess, path, pageReferrer]);
};

export default useGTM;
